export default {
  home: {
    minute: 'minute',
    price_info: 'Gratuit pour les {mianfei} premières mins. Maximum {currencyName}{fengding} par jour. La caution sera automatiquement déduite quand la location atteint {currencyName}{yajin}',
    feature_1: 'Adapté à tous les types de téléphones mobiles',
    feature_2: 'Peut être retourné dans n\'importe quelle autre station',
    feature_3: 'Conception spéciale - chargement sans fil (uniquement pour les modules pris en charge)',
    tips_1: 'Votre caution de {currencyName}{yajin} vous sera remboursée après le retour de la batterie externe.',
    yajin_info: 'Maximum {currencyName}{fengding} par jour',
    tips_2: 'La caution {currencyName}{yajin} peut être louée, utilisée puis remboursée',
    tips_3: 'Le solde actuel est {currencyName}{myyue}, peut être loué directement',
    submit: 'Recharger',
    borrow: 'Louer',
    msg_fail_title: 'Erreur',
    msg_fail_content: 'Échec de la location, veuillez réessayer',
    msg_rentcount: 'Vous avez actuellement {zujieNum} commandes non closes',
    goborrow: 'Aller charger!!!',
    nearby: 'Voir les points à proximité',
    preauth: 'Pré-autorisation',
    shopTime: 'Horaires d\'ouverture',
    分钟: 'minute',
    小时: 'heure',
    天: 'jour'
  },
  button: {
    添加新卡: 'Ajouter une nouvelle carte',
    delete_card: 'Supprimer la carte',
    Delete: 'Supprimer'
  },
  selectpackage: {
    powerbank: 'Batterie externe',
    powerstation: 'Station d\'alimentation',
    wifibox: 'Boîtier WiFi',
    choosepackage: 'Choisir un forfait',
    minute: 'minute',
    首次免费: 'Gratuit pour les premières ',
    最大每日收费: 'Frais maximaux quotidiens: ',
    devicedeposit: 'Caution de l\'équipement',
    return_will_back: 'La caution est remboursée après le retour de l\'équipement',
    lengthofuse: 'Durée d\'utilisation',
    amountcharged: 'Montant accumulé',
    release_powerbank: 'Libérer la batterie externe',
    see_pricing: 'Voir les tarifs',
    deposit: 'caution',
    agreen: 'En continuant, vous acceptez notre ',
    privacy_policy: 'Politique de confidentialité',
    and: ' et ',
    terms_and_conditions: 'Conditions générales.',
    per: 'par'
  },
  wifimall: {
    Select: 'Sélectionner',
    subtitle: 'Forfaits recommandés',
    dayuse: 'Jours d\'utilisation',
    Verify: 'Vérifier',
    无限流量: 'Illimité',
    天: 'jour',
    days: 'jours',
    useDay: 'Jours d\'utilisation',
    mypackages: 'Sélectionner un forfait existant',
    没有更多了: 'Plus rien',
    加载中: 'Chargement',
    depositof: 'Inclut une caution de ',
    usagetime: 'Temps d\'utilisation'
  },
  paymethod: {
    payamount: 'Montant',
    choosepaymethod: 'Choisir le mode de paiement',
    addcard: 'Ajouter une nouvelle carte',
    confrimpay: 'Confirmer le paiement',
    借记卡: 'Carte de débit',
    银行卡列表: 'Liste des cartes bancaires'
  },
  login: {
    title: 'Connexion ou inscription',
    code_title: 'Vérification SMS',
    phone_number: 'Numéro de téléphone',
    verification_code: 'Veuillez entrer le code de vérification SMS. Si vous n\'avez pas de code, essayez une autre méthode de connexion.',
    captcha_code: 'Code',
    send_code: 'Envoyer le code',
    login: 'Connexion',
    agree: 'En vous connectant, vous acceptez ',
    readme: 'Accord utilisateur',
    msg_fail_login: 'Échec de connexion',
    msg_success_login: 'Connexion réussie',
    msg_fail_user: 'Erreur lors de la récupération des informations utilisateur. Voulez-vous réessayer?',
    sign_in_with: 'Se connecter avec',
    no_sms: 'Pas de message reçu',
    retry: 'Renvoyer',
    applelogin: 'Se connecter avec Apple',
    otherlogin: 'Autres options',
    quicklogin: 'Connexion rapide',
    mobilelogin: 'Connexion mobile',
    emaillogin: 'Connexion par e-mail',
    facelogin: 'Se connecter avec Facebook'
  },
  confirm: {
    'Credit Card': 'Carte de crédit',
    WeChat: 'WeChat',
    'Apple Pay': 'Apple Pay',
    'Google Pay': 'Google Pay',
    'SMS Payment': 'Paiement SMS',
    'Idael Pay': 'Idael Pay',
    title: 'Confirmation de paiement',
    savenow: 'Sauvegarder',
    confirmpay: 'Confirmer le paiement',
    SMSConfirm: 'Veuillez payer selon le message reçu sur votre téléphone et cliquez sur confirmer.',
    pay_label: 'Montant',
    auth_label: 'Pré-autorisation',
    price_tips: 'Votre solde peut être retiré sur demande. Cela peut prendre 1-5 jours ouvrables.',
    auth_tips: 'Un montant de pré-autorisation de {0}{1} est obligatoire. Le montant réel de la location sera déduit lors du retour de la batterie.',
    pay_type: 'Veuillez sélectionner votre mode de paiement préféré',
    submit: 'Confirmer le paiement',
    msg_loading: 'Chargement...',
    msg_fail_title: 'Avertissement',
    msg_fail_payment: 'Échec du paiement de la caution',
    msg_fail_order: 'Échec de la création de la commande de location',
    msg_fail_support: 'Système non pris en charge',
    msg_fail_confirm: 'Confirmer',
    msg_fail_retry: 'Réessayer',
    msg_fail_cancel: 'Annuler',
    msg_none_msg: 'Veuillez entrer d\'autres informations pour vous identifier'
  },
  mine: {
    title: 'Profil utilisateur',
    wallet: 'Mon portefeuille',
    balance: 'Mon solde',
    deposit: 'Caution',
    wallet_in: 'Recharger',
    wallet_out: 'Retirer',
    wallet_log: 'Historique',
    order: 'Commande',
    coupon: 'Coupon',
    login_tips: 'Veuillez vous connecter',
    msg_fail_title: 'Erreur',
    msg_fail_update: 'Échec de la modification, veuillez réessayer',
    msg_loading: 'Chargement...',
    msg_fail_user: 'Erreur lors de la récupération des informations utilisateur. Réessayer?',
    help: 'Aide',
    setting: 'Paramètres',
    logout: 'Déconnexion',
    buy: 'Acheter un appareil',
    aboutus: 'À propos de nous',
    contactus: 'Nous contacter'
  },
  msg: {
    no_phone: 'Le numéro de téléphone est requis',
    loading: 'Chargement...',
    title: 'Indication',
    success: 'Opération réussie',
    sendsuccess: 'Envoyé avec succès',
    error: 'Erreur inconnue, veuillez réessayer plus tard.',
    deletecard: 'Voulez-vous vraiment supprimer cette carte?',
    confirm: 'Confirmer',
    retry: 'Réessayer',
    cancel: 'Annuler',
    title_fail: 'Avertissement',
    vieworder: 'Voir la commande',
    success_payment: 'Paiement terminé',
    success_buy: 'Achat terminé',
    fail_payment: 'Échec du paiement',
    keyword: 'mot-clé',
    nodata: 'Aucune donnée',
    copysuccess: 'Copie réussie',
    notopen: 'Pas encore ouvert',
    devicenotactivated: 'Appareil non activé',
    pickup_fail: 'Échec de la récupération de l\'appareil. Veuillez réessayer plus tard',
    msg_none_name: 'Veuillez entrer votre prénom',
    msg_none_email: 'Veuillez entrer votre adresse e-mail',
    msg_none_mobile: 'Veuillez entrer votre numéro de téléphone',
    msg_none_nation: 'Veuillez entrer votre pays',
    msg_none_msg: 'Veuillez entrer d\'autres informations pour vous identifier',
    msg_fail_choosepackage: 'Veuillez sélectionner un point de retrait',
    geolocationfailed: 'Erreur: Le service de géolocalisation a échoué.'
  },
  result: {
    title: 'Confirmation du résultat',
    price_plan: 'Tarif de chargement',
    msg_success: 'Location réussie',
    msg_tips_loading: 'La batterie externe sort, veuillez patienter...',
    msg_result_loading: 'Le résultat du paiement est en cours de confirmation...',
    msg_fail_confirm: 'Confirmer',
    btn_usage: 'Notice d\'utilisation',
    btn_return: 'Notice de retour',
    deposit: 'Caution',
    msg_fail_content: 'Échec de la demande, veuillez réessayer',
    price_label: 'par heure',
    price_info: 'Gratuit pour les {mianfei} premières mins, maximum {ccurrency}{fengding} par jour, la caution est automatiquement déduite quand la location atteint {ccurrency}{yajin}',
    tips_1: 'Veuillez récupérer la batterie externe <span class="number">N° {number}</span> comme indiqué',
    tips_2: 'Veuillez ranger les câbles et insérer la batterie avec le <span class="highlight">[flèche vers le bas]</span> lors du retour',
    msg_note_usage: 'La batterie dispose de 3 types de câbles et de chargement sans fil, utilisez selon vos besoins.',
    msg_note_return: 'Veuillez ranger les câbles et insérer la batterie avec la [flèche vers le bas] lors du retour.',
    return_info: 'Pour le retour: rangez les câbles et insérez le côté avec les contacts métalliques dans une prise vide jusqu\'au fond.'
  },
  result_msg: {
    loading: 'Chargement...',
    refresh: 'Actualiser'
  },
  order: {
    title: 'Commande de location',
    in_use: 'En cours',
    ended: 'Terminé',
    enter_order_email: 'Veuillez entrer votre e-mail',
    msg_error: 'Échec de la demande'
  },
  order_item: {
    order_number: 'N°',
    venue_rented: 'Point de retrait',
    time_rented: 'Heure de retrait',
    venue_returned: 'Point de retour',
    time_returned: 'Heure de retour',
    charge_standard: 'Tarif',
    charge_standard_info: '{pJifei} {pCurrency} par heure (premières {pMian} mins gratuites)',
    rent_occurred: 'Loyer encouru',
    returned: 'Retourné',
    unreturned: 'Non retourné',
    type_0: 'Non terminé',
    type_1: 'En location',
    type_2: 'Annulé',
    type_3: 'Retourné',
    type_4: 'Panne',
    type_5: 'En retard',
    min: 'Min',
    payment: 'Paiement'
  },
  setting: {
    title: 'Paramètres',
    lang: 'Langue'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Recharge de solde',
    price_label: 'Montant de recharge',
    price_placeholder: 'Veuillez entrer le montant de recharge',
    balance: 'Solde actuel',
    price_auto: 'Choisir le montant',
    price_tips: 'Votre solde peut être retiré sur demande. Cela peut prendre 1-5 jours ouvrables.',
    submit: 'Soumettre',
    loading: 'Chargement...',
    paying: 'Redirection vers la page de paiement...',
    msg_title: 'Astuce',
    msg_fail_order: 'Échec de la création de la commande',
    msg_fail_payment: 'Échec du paiement',
    msg_fail_retry: 'Réessayer',
    选择充值金额: 'Sélectionner le montant',
    输入充值金额: 'Entrer le montant',
    确认充值: 'Confirmer la recharge'
  },
  wallet_out: {
    title: 'Retrait',
    price_label: 'Montant du retrait',
    price_placeholder: 'Veuillez entrer le montant du retrait',
    balance: 'Solde actuel',
    balance_all: 'Tout retirer',
    deposit: 'Caution',
    deposit_tips: 'Il y a une commande de location. La caution de {pcurrencyName}{pyajin} n\'est pas remboursable',
    submit: 'Soumettre',
    apply: 'Appliquer',
    confirm: 'Confirmer',
    loading: 'Chargement...',
    msg_fail_price: 'Le montant du retrait est incorrect',
    msg_fail_balance: 'Le montant ne peut pas dépasser le solde actuel',
    msg_fail_submit: 'Veuillez remplir toutes les informations',
    msg_title: 'Erreur',
    msg_success_content: 'Remboursement demandé avec succès',
    confirmtitle: 'Astuce',
    confirmcontent: 'Le portefeuille actuel ne prend pas en charge les retraits en espèces. Veuillez noter vos coordonnées pour un remboursement manuel',
    payee_name: 'Nom du bénéficiaire',
    payee_bankcard: 'Numéro de carte',
    payee_phone: 'Téléphone',
    cancelText: 'Annuler',
    confirmText: 'Redemander',
    退款金额: 'Montant du remboursement'
  },
  map: {
    title: 'Équipements à proximité',
    result_msg: 'Aucun équipement trouvé à proximité',
    msg_title: 'erreur',
    no_support: 'Désolé! Votre navigateur ne prend pas en charge la géolocalisation',
    my_position: 'Ma position',
    distance: 'distance:',
    shop_time: 'heures',
    free: 'louable',
    return: 'retournable',
    shop_title: 'Détails du commerçant',
    address: 'adresse',
    go_here: 'Y aller'
  },
  scanOrder: {
    viewflowdetail: 'Voir les détails d\'utilisation',
    confirmpickup: 'Confirmation de retrait',
    QRpickup: 'Retrait par QR code',
    取机中: 'Retrait',
    scanQR: 'Scanner le QR code pour lier',
    qrCodePickup: 'Retrait QR code',
    orderNo: 'N° de commande',
    startingTime: 'Heure de début',
    endTime: 'Heure de fin',
    packageStatus: 'Statut du forfait',
    无限流量: 'Illimité',
    天: 'jour',
    days: 'jours',
    type_0: 'Non utilisé',
    type_1: 'À activer',
    type_2: 'Activé',
    type_3: 'Révoqué',
    type_4: 'Remboursé',
    type_9: 'Terminé',
    type_33: 'Non payé',
    type_88: 'Annulé',
    inputserialNumber: 'Veuillez entrer le numéro de série de l\'appareil',
    pickupsuccess: 'Appareil récupéré avec succès',
    continuepay: 'Continuer le paiement'
  },
  borrowSuccess: {
    success: 'Location réussie',
    renewalTraffic: 'Renouveler le forfait',
    viewOrder: 'Voir la commande',
    HowUseDevice: 'Comment utiliser l\'appareil',
    download_tips: 'Vous pouvez laisser votre e-mail et nous vous enverrons les détails de cette commande',
    download_tips2: 'Pour voir d\'autres points de retour, veuillez télécharger l\'application.',
    download: 'Télécharger',
    loading_title: 'Déverrouillage de la batterie',
    loading_tips: 'Veuillez patienter...',
    send: 'Envoyer'
  },
  packageOrder: {
    viewdetail: 'Voir les détails',
    buynow: 'Acheter maintenant',
    isrent: 'L\'équipement est-il loué?',
    timelimited: 'Offre limitée'
  },
  packageDetail: {
    WiFiName: 'Nom WiFi',
    WiFiPassword: 'Mot de passe WiFi',
    batteryLife: 'Batterie',
    Signal: 'Signal',
    orderNo: 'N° de commande',
    startingTime: 'Heure de début',
    endTime: 'Heure de fin',
    packageStatus: 'Statut du forfait',
    usedTraffic: 'Données utilisées',
    Renewals: 'Acheter du forfait',
    inuse: 'En cours'
  },
  orderDetail: {
    price1: '{pCurrencyName}{pJifei} par {pJifeiDanwei}{priceUnit}',
    price2: 'Jusqu\'à {pCurrencyName}{pFengding} par 24 heures',
    price3: 'Frais de non-retour de {pCurrencyName}{overtimeAmount}',
    venuerented: 'Point de retrait',
    venuereturned: 'Point de retour',
    timerented: 'Heure de location',
    timereturned: 'Heure de retour',
    powerbankid: 'ID Batterie',
    getreceipt: 'OBTENIR UN REÇU',
    buypowerbank: 'Acheter cette batterie',
    usetime: 'Temps d\'utilisation',
    estimatedamount: 'Montant estimé',
    feerule: 'Règle de frais',
    payment: 'Paiement',
    orderNo: 'N° de commande',
    trafficDetails: 'Voir les détails du forfait',
    Renewals: 'Renouvellements',
    FeeSchedule: 'Grille des frais',
    HowToUse: 'Comment utiliser',
    LeaseMerchant: 'Point de location',
    startTime: 'Heure de début',
    ReturningMerchants: 'Point de retour',
    EndTime: 'Heure de fin',
    Deposit: 'Caution',
    fee1: 'Caution équipement 500€',
    fee2: 'Retour dans les 7 jours après expiration: moins 10€/jour/unité.',
    fee3: 'Retour dans les 7 jours après expiration: 200€/unité seront déduits.',
    fee4: 'La caution est automatiquement déduite si l\'équipement n\'est pas retourné plus de 15 jours après expiration.',
    rentagain: 'Louer à nouveau',
    onrental: 'En location',
    revoked: 'Révoqué',
    returned: 'Retourné',
    issue: 'Problème',
    overtimereturn: 'Retard'
  },
  pickUp: {
    orderNo: 'N° de commande',
    startingTime: 'Heure de début',
    endTime: 'Heure de fin',
    packageStatus: 'Statut du forfait',
    confirmationOfPickup: 'Confirmation de retrait'
  },
  aboutus: {
    title: 'À propos de nous',
    desc1: 'BajieCharging est une marque de solutions partagées de batteries externes de Shenzhen Bajie Charging Technology Co., Ltd. Depuis sa création en 2018, l\'entreprise se concentre sur la recherche et l\'opération d\'appareils terminals intelligents dans le domaine de l\'économie du partage. Grâce à l\'innovation technologique continue, divers appareils intelligents ont été développés.',
    desc2: 'BaJie Charging a développé un modèle de coopération OEM mature. Nous fournissons les équipements et le support technique, vous gérez votre propre service.',
    contactustitle: 'Intéressé par un partenariat avec ChargeNow? Contactez-nous——',
    formtitle: 'Une question? Contactez-nous!',
    submit: 'Soumettre',
    name: 'Nom',
    email: 'E-mail',
    tel: 'Tél',
    nation: 'Pays',
    message: 'Message'
  },
  contactus: {
    title: 'Nous contacter',
    desc1: 'ChargeNow est une marque de solutions de partage de batteries externes de Shenzhen Bajie Charging Technology Co., Ltd. ChargeNow opère un service de partage de batteries à travers le monde.',
    desc2: 'Si vous êtes intéressé par une partnership de franchise, veuillez contacter notre siège en Chine.',
    contactustitle: 'Siège Chine',
    contactussubtitle: 'Bâtiment 5, 2e–4e étages, Fuzhong Industrial Park, Huaide Community, Fuyong Subdistrict, Shenzhen Code postal: 518128',
    contactusinfotitle: 'Pour les utilisateurs finaux rencontrant des problèmes, veuillez contacter votre franchiseur local:',
    method1: 'GRANSOL BRASIL',
    methoddesc1: 'Av. Ana Costa, 61 EV 506 Santos/SP CEP 11060-001',
    method2: 'Région Kazakhstan',
    methoddesc2: 'Ville d\'Aktau'
  },
  rentcost: {
    rentcosttitle: 'Combien coûte la location?',
    price1: '{currency} {jifei} par {jifeiDanwei} {priceUnit}',
    price2: '{currency} {fengding} par jour',
    tip1: 'Si vous ne retournez pas la batterie dans {overtime}, {overtimeAmount} {currency} seront facturés et vous n\'aurez pas à la retourner.',
    tip2: 'Un jour de location = 24 heures à partir du retrait.',
    tip3: 'Nous facturons {yajin} {currency} de caution qui sera remboursée au retour.',
    tip4: 'Certains points offrent des heures gratuites ou des réductions. Profitez-en!',
    Days: 'Jours',
    Hours: 'Heures',
    Minutes: 'Minutes',
    free: '{mianfei} minutes gratuites',
    willcharged: '{currency} {money} vous seront facturés'
  },
  payment: {
    title: 'Paiement par carte bancaire',
    cardNumber: 'Numéro de carte',
    cardNumberPlaceholder: 'Entrez le numéro de carte',
    cardHolder: 'Nom du titulaire',
    cardHolderPlaceholder: 'Entrez le nom',
    expiryDate: 'Date d\'expiration',
    cvv: 'CVV',
    cvvPlaceholder: 'CVV',
    cardType: 'Type de carte',
    selectCardType: 'Sélectionner le type',
    creditCard: 'Carte de crédit',
    debitCard: 'Carte de débit',
    month: 'Mois',
    year: 'Année',
    payNow: 'Payer maintenant',
    processing: 'Traitement...',
    success: 'Paiement réussi',
    failed: 'Paiement échoué',
    close: 'Fermer',
    paymentSuccess: 'Paiement réussi! Merci pour votre achat.',
    paymentFailed: 'Paiement échoué, veuillez réessayer ou utiliser un autre mode de paiement.',
    networkError: 'Erreur réseau, vérifiez votre connexion et réessayez.'
  },
  validation: {
    cardNumberRequired: 'Le numéro de carte est requis',
    cardNumberDigitsOnly: 'Le numéro doit contenir uniquement des chiffres',
    unsupportedCardType: 'Type de carte non pris en charge',
    invalidCardLength: 'Le numéro doit avoir {lengths} chiffres',
    invalidCardNumber: 'Numéro de carte invalide',
    cardHolderRequired: 'Le nom du titulaire est requis',
    expiryRequired: 'La date d\'expiration est requise',
    cardExpired: 'Carte expirée',
    cvvRequired: 'Le CVV est requis',
    cvvDigitsOnly: 'Le CVV doit contenir uniquement des chiffres',
    invalidCvvLength: 'Le CVV doit avoir {length} chiffres',
    cardTypeRequired: 'Le type de carte est requis'
  }
}
